import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { VideoPlayerComponent } from '../../video-player.component';
import { Scene } from '../../../../model/scene';
import { SceneCardComponent } from './scene-card/scene-card.component';
import { MatIconModule } from '@angular/material/icon';
import { VideoSceneService } from 'src/app/features/video/controller/video-scene.service';
import { RfebmPrimaryButtonComponent } from 'src/app/ui/atoms/rfebm-primary-button/rfebm-primary-button.component';

@Component({
  selector: 'app-scene-selector',
  templateUrl: 'scene-selector.component.html',
  styleUrls: ['scene-selector.component.scss'],
  standalone: true,
  imports: [CommonModule, SceneCardComponent, MatIconModule, RfebmPrimaryButtonComponent]
})
export class SceneSelectorComponent implements OnInit {

  @Input() label: string = 'Scenes in this video';
  @Input() videoPlayer: VideoPlayerComponent;
  @Input() loop: boolean = false; // Looping the scene instead of continuing to the next one
  @Input() isCollapsed: boolean = false;

  @Output() onSceneSelected = new EventEmitter<Scene>();
  @Output() onScenesLoaded = new EventEmitter<void>();

  skeletonScenes: Scene[] = [null, null, null, null, null];

  scenes: Scene[] = null;

  constructor(
    private videoSceneService: VideoSceneService
  ) { }

  ngOnInit() {
    this.loadScenes();
  }

  sceneSelected(scene: Scene) {
    this.onSceneSelected.emit(scene);
  }

  async loadScenes() {
    this.scenes = await this.videoSceneService.getScenes(this.videoPlayer.video);
    if (this.scenes) {
      this.onScenesLoaded.emit();
    }
  }
}


